import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100%;

  ${Media.AboveTablet`
    gap: 10px;
  `};
`

export const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
`

export const Value = styled.p`
  color: ${Colors.White};
  ${Typography.Body};
  ${FontWeights.Regular};
`
